"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dialogBodyClassNames: function() {
        return dialogBodyClassNames;
    },
    useDialogBodyStyles_unstable: function() {
        return useDialogBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const dialogBodyClassNames = {
    root: 'fui-DialogBody'
};
/**
 * Styles for the root slot
 */ const useResetStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r71plkv", null, {
    r: [
        ".r71plkv{overflow-x:unset;overflow-y:unset;column-gap:8px;row-gap:8px;display:grid;max-height:calc(100vh - 2 * 24px);box-sizing:border-box;grid-template-rows:auto 1fr;grid-template-columns:1fr 1fr auto;}"
    ],
    s: [
        "@media screen and (max-width: 480px){.r71plkv{max-width:100vw;grid-template-rows:auto 1fr auto;}}"
    ]
});
const useDialogBodyStyles_unstable = (state)=>{
    const resetStyles = useResetStyles();
    state.root.className = (0, _react.mergeClasses)(dialogBodyClassNames.root, resetStyles, state.root.className);
    return state;
}; //# sourceMappingURL=useDialogBodyStyles.styles.js.map
